<template>
    <div>
        <CRow>
            <CCol>
                <CCard>
                    <CCardHeader>
                        <strong>Создание помощника</strong>
                    </CCardHeader>

                    <CCardBody>
                        <AssistantUpsertForm @success="$router.push('/assistants')" @dismiss="$router.go(-1)" />
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
    import AssistantUpsertForm from '@/components/assistant/AssistantUpsertForm'

    export default {
        name: 'AssistantCreate',

        components: {
            AssistantUpsertForm,
        },
    }
</script>

<style>

</style>
